"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientSMSSecret = exports.ClientSMSFeature = exports.RequestClient = exports.Client = exports.AgencyClientType = exports.LongClient = exports.ClientStatusEnum = exports.ShortClient = exports.AgencySearchClient = exports.MinimalClient = exports.NamedClient = exports.ClientType = exports.Bryx911ClientType = void 0;
var cerealParse_1 = require("../cerealParse");
var agency_1 = require("./agency");
var hospital_1 = require("./hospital");
var device_1 = require("./device");
var request_1 = require("./request");
var Bryx911ClientType;
(function (Bryx911ClientType) {
    Bryx911ClientType[Bryx911ClientType["user"] = 0] = "user";
    Bryx911ClientType[Bryx911ClientType["truck"] = 1] = "truck";
    Bryx911ClientType[Bryx911ClientType["unknown"] = 2] = "unknown";
})(Bryx911ClientType || (exports.Bryx911ClientType = Bryx911ClientType = {}));
var ClientType;
(function (ClientType) {
    ClientType[ClientType["user"] = 0] = "user";
    ClientType[ClientType["truck"] = 1] = "truck";
    ClientType[ClientType["commsNurse"] = 2] = "commsNurse";
    ClientType[ClientType["unknown"] = 3] = "unknown";
})(ClientType || (exports.ClientType = ClientType = {}));
var NamedClient = /** @class */ (function () {
    function NamedClient(id, name) {
        this.id = id;
        this.name = name;
    }
    NamedClient.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new NamedClient(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid NamedClient Model: ".concat(e.message));
        }
    };
    return NamedClient;
}());
exports.NamedClient = NamedClient;
var MinimalClient = /** @class */ (function () {
    function MinimalClient(id, email, commonName) {
        this.id = id;
        this.email = email;
        this.commonName = commonName;
    }
    MinimalClient.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MinimalClient(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'email'), cerealParse_1.ParseUtils.getString(o, 'commonName')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MinimalClient Model: ".concat(e.message));
        }
    };
    return MinimalClient;
}());
exports.MinimalClient = MinimalClient;
var AgencySearchClient = /** @class */ (function () {
    function AgencySearchClient(id, email, commonName, 
    // AgencySearchClient Specific
    isManager, type, lastInteractionTime) {
        this.id = id;
        this.email = email;
        this.commonName = commonName;
        this.isManager = isManager;
        this.type = type;
        this.lastInteractionTime = lastInteractionTime;
    }
    AgencySearchClient.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AgencySearchClient(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'email'), cerealParse_1.ParseUtils.getString(o, 'commonName'), 
            // AgencySearchClient Specific
            cerealParse_1.ParseUtils.getBoolean(o, 'isManager'), cerealParse_1.ParseUtils.getEnum(o, 'bryx911Type', Bryx911ClientType, Bryx911ClientType.unknown), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'lastInteractionTime')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid AgencySearchClient Model: ".concat(e.message));
        }
    };
    AgencySearchClient.prototype.isBryx = function () {
        return this.email.toLowerCase().indexOf('bryx') != -1;
    };
    AgencySearchClient.prototype.nameEmailString = function () {
        return "".concat(this.commonName, " <").concat(this.email, ">");
    };
    return AgencySearchClient;
}());
exports.AgencySearchClient = AgencySearchClient;
var ShortClient = /** @class */ (function () {
    function ShortClient(id, email, commonName, type, lastInteractionTime, status, initials, agencies) {
        this.id = id;
        this.email = email;
        this.commonName = commonName;
        this.type = type;
        this.lastInteractionTime = lastInteractionTime;
        this.status = status;
        this.initials = initials;
        this.agencies = agencies;
    }
    ShortClient.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ShortClient(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'email'), cerealParse_1.ParseUtils.getString(o, 'commonName'), cerealParse_1.ParseUtils.getEnum(o, 'clientType', ClientType), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'lastInteractionTime'), 
            // ShortClient Specific
            cerealParse_1.ParseUtils.getEnum(o, 'status', ClientStatusEnum), cerealParse_1.ParseUtils.getString(o, 'initials'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'agencies', agency_1.ShortClientAgency.parse, 'warn').sort(agency_1.ShortClientAgency.compare)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ShortClient Model: ".concat(e.message));
        }
    };
    return ShortClient;
}());
exports.ShortClient = ShortClient;
var ClientStatusEnum;
(function (ClientStatusEnum) {
    ClientStatusEnum["active"] = "active";
    ClientStatusEnum["banned"] = "banned";
    ClientStatusEnum["deleted"] = "deleted";
    ClientStatusEnum["disabled"] = "disabled";
})(ClientStatusEnum || (exports.ClientStatusEnum = ClientStatusEnum = {}));
var LongClient = /** @class */ (function () {
    function LongClient(id, email, commonName, status, type, initials, lastInteractionTime, agencies, givenName, hospitals, surname, phoneNumber, onDuty, requests, devices, sendAlertForEachUnit, avlId) {
        this.id = id;
        this.email = email;
        this.commonName = commonName;
        this.status = status;
        this.type = type;
        this.initials = initials;
        this.lastInteractionTime = lastInteractionTime;
        this.agencies = agencies;
        this.givenName = givenName;
        this.hospitals = hospitals;
        this.surname = surname;
        this.phoneNumber = phoneNumber;
        this.onDuty = onDuty;
        this.requests = requests;
        this.devices = devices;
        this.sendAlertForEachUnit = sendAlertForEachUnit;
        this.avlId = avlId;
    }
    LongClient.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new LongClient(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'email'), cerealParse_1.ParseUtils.getString(o, 'commonName'), cerealParse_1.ParseUtils.getEnum(o, 'status', ClientStatusEnum), cerealParse_1.ParseUtils.getEnum(o, 'clientType', ClientType), cerealParse_1.ParseUtils.getString(o, 'initials'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'lastInteractionTime'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'agencies', agency_1.LongClientAgency.parse, 'warn').sort(agency_1.LongClientAgency.compare), cerealParse_1.ParseUtils.getStringOrNull(o, 'givenName'), cerealParse_1.ParseUtils.getArrayOfSubobjectsOrNull(o, 'hospitals', hospital_1.MinimalHospital.parse, 'warn'), cerealParse_1.ParseUtils.getStringOrNull(o, 'surname'), cerealParse_1.ParseUtils.getStringOrNull(o, 'phone'), cerealParse_1.ParseUtils.getBoolean(o, 'receiveNotifications'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'requests', request_1.Request.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'devices', device_1.Device.parse, 'throw'), cerealParse_1.ParseUtils.getBoolean(o, 'sendAlertForEachUnit'), cerealParse_1.ParseUtils.getStringOrNull(o, 'avlId')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid LongClient Model: ".concat(e.message));
        }
    };
    LongClient.prototype.isAgencyMember = function (agencyId) {
        return this.agencies.filter(function (a) { return a.id == agencyId; }).length > 0;
    };
    LongClient.prototype.getCopy = function () {
        return new LongClient(this.id, this.email, this.commonName, this.status, this.type, this.initials, this.lastInteractionTime, this.agencies, this.givenName, this.hospitals, this.surname, this.phoneNumber, this.onDuty, this.requests, this.devices, this.sendAlertForEachUnit, this.avlId);
    };
    return LongClient;
}());
exports.LongClient = LongClient;
var AgencyClientType;
(function (AgencyClientType) {
    AgencyClientType[AgencyClientType["user"] = 0] = "user";
    AgencyClientType[AgencyClientType["apparatus"] = 1] = "apparatus";
})(AgencyClientType || (exports.AgencyClientType = AgencyClientType = {}));
/**
 * Class representing a client.
 */
var Client = /** @class */ (function () {
    function Client(id, commonName, type) {
        this.id = id;
        this.commonName = commonName;
        this.type = type;
    }
    return Client;
}());
exports.Client = Client;
/**
 * Class representing a request client and providing a static parse method.
 */
var RequestClient = /** @class */ (function () {
    function RequestClient(id, email, commonName) {
        this.id = id;
        this.email = email;
        this.commonName = commonName;
    }
    /**
     * Parse object potentially representing a RequestClient.
     * @param o
     * @return Parse result
     */
    RequestClient.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new RequestClient(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'email'), cerealParse_1.ParseUtils.getString(o, 'commonName')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid RequestClient: ".concat(e.message));
        }
    };
    return RequestClient;
}());
exports.RequestClient = RequestClient;
/**
 * Class representing a client's SMS feature status
 */
var ClientSMSFeature = /** @class */ (function () {
    function ClientSMSFeature(enabled, credits, stripeCustomerId, error, smsPerMonth) {
        this.enabled = enabled;
        this.credits = credits;
        this.stripeCustomerId = stripeCustomerId;
        this.error = error;
        this.smsPerMonth = smsPerMonth;
    }
    /**
     * Parse object potentially representing a RequestClient.
     * @param o
     * @return Parse result
     */
    ClientSMSFeature.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ClientSMSFeature(cerealParse_1.ParseUtils.getBoolean(o, 'enabled'), cerealParse_1.ParseUtils.getNumber(o, 'credits'), cerealParse_1.ParseUtils.getStringOrNull(o, 'stripeCustomerId'), cerealParse_1.ParseUtils.getStringOrNull(o, 'error'), cerealParse_1.ParseUtils.getNumber(o, 'smsPerMonth')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ClientSMSFeature: ".concat(e.message));
        }
    };
    return ClientSMSFeature;
}());
exports.ClientSMSFeature = ClientSMSFeature;
/**
 * Class representing the return model for a client secret
 */
var ClientSMSSecret = /** @class */ (function () {
    function ClientSMSSecret(clientSecret) {
        this.clientSecret = clientSecret;
    }
    /**
     * Parse object potentially representing a RequestClient.
     * @param o
     * @return Parse result
     */
    ClientSMSSecret.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ClientSMSSecret(cerealParse_1.ParseUtils.getString(o, 'client_secret')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ClientSMSSecret: ".concat(e.message));
        }
    };
    return ClientSMSSecret;
}());
exports.ClientSMSSecret = ClientSMSSecret;
//# sourceMappingURL=client.js.map